import { render, staticRenderFns } from "./LayoutPublicThin.vue?vue&type=template&id=e0c6d30a"
import script from "./LayoutPublicThin.vue?vue&type=script&lang=js"
export * from "./LayoutPublicThin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports